import authConfig, { type AuthConfig } from '@erikdakoda/auth/shared/config';

const config: AuthConfig = {
  pages: {
    home: '/',
    authHome: '/',
    login: '/login',
    signup: '/signup',
    forgot: '/forgot',
    reset: '/reset',
    verify: '/verify',
    verifyToken: '/verify/[[...token]]',
    security: '/user/settings/security',
  },

  adminUsers: ['erik@erikdakoda.com', 'erik@uvilo.com'],
};

function register() {
  authConfig.config = config;
}

export default register;
